import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const themePlanApi = createApi({
  reducerPath: 'themePlanApi',
  keepUnusedDataFor: 1,
  baseQuery: fetchBaseQuery({
    baseUrl: '/ThemePlan',
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    getThemesListForEmployee: builder.query({
      query: ({courseId, disciplineId, virtualGroupId}) => ({
        url: `/ThemesListForEmployee`,
        method: 'GET',
        params: {courseId, disciplineId, virtualGroupId}
      }),
    }),
    getThemesList: builder.query({
      query: ({courseId, disciplineId, virtualGroupId}) => ({
        url: `/ThemesList`,
        method: 'GET',
        params: {courseId, disciplineId, virtualGroupId}
      }),
    }),
    saveThemes: builder.mutation({
      query: ({ data }) => ({
        url: `/SaveThemes`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Post'],
    }),
    removeTheme: builder.mutation({
      query: ({ data }) => ({
        url: `/RemoveTheme`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Post'],
    }),
  }),
});

export const {
  useGetThemesListForEmployeeQuery,
  useGetThemesListQuery,
  useSaveThemesMutation,
  useRemoveThemeMutation,
} = themePlanApi;
